





















































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Menu from '../../apiClient/Menu';
import Company from '../../apiClient/Company';
import PopupLegajoDigital from '../generics/PopupLegajoDigital.vue';
import _ from 'lodash';
import Config from '@/config/index';
import Actions from '../../apiClient/Actions';
import { BasicClient } from '@/utils/httpClient';

@Component({
  name: 'LeftAside',
  components: { PopupLegajoDigital: Vue.extend(PopupLegajoDigital) },
  directives: {
    toggleActive: {
      inserted: function (el) {
        el.addEventListener('click', () => {
          let actives = document.getElementsByClassName('m-menu__item--active');
          if (actives.length > 0) {
            _.each(actives, (active, index) => {
              actives[index].classList.remove('m-menu__item--active');
            });
          }
          el.parentNode['className'] += ' m-menu__item--active';

          /* menu collapses every time you click over a submenu item */
          let opened = document.getElementsByClassName('m-menu__item--open');
          if (opened.length > 0) {
            _.each(opened, (menu, index) => {
              if (opened[index]) {
                opened[index].classList.remove('m-menu__item--open');
              }
            });
          }
        });
      },
    },
    toggleSelected: {
      inserted: function (el) {
        el.addEventListener('click', () => {
          /* highlights the current selected menu */
          let selected = document.getElementsByClassName(
            'm-menu__item--selected'
          );
          if (selected.length > 0) {
            _.each(selected, (el, index) => {
              selected[index].classList.remove('m-menu__item--selected');
            });
          }
          el.parentNode['className'] += ' m-menu__item--selected';
        });
      },
    },
    autoCollapse: {
      //TODO: terminar esta vaina que autocolapse los submenues al hacer mouseleave en el menu lateral
      inserted: function (el) {
        el.addEventListener('mouseleave', () => {
          let opened = document.getElementsByClassName('m-menu__item--open');
          if (opened.length > 0) {
            _.each(opened, (menu, index) => {
              if (opened[index]) {
                opened[index].classList.remove('m-menu__item--open');
              }
            });
          }
        });
      },
    },
  },
  computed: {
    showNotifyPush: function () {
      return (
        this.$store.state.notifyPushVisualizations === 1 &&
        this.$store.state.notifyPush &&
        (this.$route.name === 'home' || this.$store.state.notifyPush.sticky) &&
        !sessionStorage.getItem('notifyPush')
      );
    },
  },
  beforeMount() {
    this.$forceUpdate();
  },
  watch: {
    '$store.state.newDocumentsWaiting': function () {
      const response = this.$store.state.newDocumentsWaiting;
      this.notifications = response.hasOwnProperty('pagination')
        ? response.pagination
        : 0;
    },
    '$store.state.documentsWaiting': function () {
      const response = this.$store.state.documentsWaiting;
      this.notifications = response.hasOwnProperty('pagination')
        ? response.pagination.total
        : 0;
    },
  },
})
export default class LeftAside extends Vue {
  actions = [];
  menu = [];
  $router: any;
  popupActive: boolean;
  showMenuLegajoDigital: boolean;
  showMenuLicencias: boolean;
  showMainMenu: boolean;
  permisionNotifications: boolean;
  notifications: number;
  data() {
    return {
      menu: [
        // {
        //   code: 'menu_2',
        //   icon: 'icon-Legajo',
        //   name: 'Documentos',
        //   childs: [3, 41, 4, 58, 19, 62],
        //   childsavailable: [],
        //   id: 7,
        //   shown: false,
        // },
        {
          code: 'menu_3',
          icon: 'icon-Licencias',
          name: 'Vacaciones y Licencias',
          href: '/gestion.licencias',
          childs: [],
          childsavailable: [],
          id: 71,
          shown: false,
          showSubMenu: false,
        },
        {
          code: 'menu_7',
          icon: 'icon-Legajo',
          name: 'Legajo Digital',
          href: '/s/employeeDatabase',
          childs: [],
          childsavailable: [],
          id: 1,
          shown: false,
          showSubMenu: false,
        },
        {
          code: 'menu_4',
          icon: 'icon-Company',
          name: 'Empresa',
          href: '/s/MainBusinessPage',
          childs: [73, 44, 30, 45, 82, 86, 104],
          childsavailable: [],
          id: 73,
          shown: false,
          showSubMenu: false,
        },
        {
          code: 'menu_5',
          icon: 'icon-Statics',
          name: 'Reporte',
          href: '/reports/main',
          childs: [],
          childsavailable: [],
          id: 38,
          shown: false,
          showSubMenu: false,
        },
      ],
      actions: {
        7: [
          {
            id: '53',
            code: 'menu_1_1',
            href: this.$router.options.base + 'employees/list',
            router: true,
            to: 'employeeslist',
            active: false,
          },
        ], // tenia id 53
        73: [
          {
            id: '1000',
            code: 'menu_6',
            href: this.$router.options.base + 'onboarding/list',
            router: true,
            to: 'oblist',
            active: false,
          },
        ],
        82: [
          {
            id: '82',
            code: 'menu_4_5',
            href: this.$router.options.base + 'folder',
            router: true,
            to: 'folder',
            active: false,
          },
        ],
        44: [
          {
            id: '44',
            code: 'menu_4_2',
            href: this.$router.options.base + 'billboard',
            router: true,
            to: 'billboard',
            active: false,
          },
        ],
        104: [
          {
            id: '104',
            code: 'menu_4_7',
            href: this.$router.options.base + 'certificates',
            router: true,
            to: 'certificates',
            active: false,
          },
        ],
        23: [{ id: '23', code: 'menu_1_2', href: '/usuario.am' }],
        40: [{ id: '40', code: 'menu_1_4', href: '/recordatorio.usuarios' }],
        //50 : [{"id" : "50", "code": "menu_1_5", "href" : "/visor.auditoria"}],
        3: [
          {
            id: '3',
            code: 'menu_2_3',
            href: this.$router.options.base + 'documents/search',
            router: true,
            to: 'documentSearch',
            active: false,
          },
        ],
        41: [
          {
            id: '62',
            code: 'menu_2_1',
            href: '',
            class: 'm-menu__item--open',
            submenu: [
              {
                id: '41',
                code: 'menu_2_1_1',
                href: this.$router.options.base + 'documents/publish/massive',
              },
              { id: '40', code: 'menu_1_4', href: '/recordatorio.usuarios' },
              { id: '4', code: 'menu_2_1_2', href: '/carga.archivo' },
              {
                id: '58',
                code: 'menu_2_1_3',
                href: '/publicacion.notificaciones',
              },
              { id: '19', code: 'menu_2_1_4', href: '/deshacer.publicacion' },
              { id: '19', code: 'menu_2_1_6', href: this.$router.options.base + '/company/process-manager' },
            ],
          },
        ],
        62: [
          {
            id: '62',
            code: 'menu_2_2',
            href: '/eforms',
            class: 'm-menu__item--open',
            submenu: [
              { id: '62', code: 'menu_2_2_1', href: '/eforms' },
              {
                id: '62',
                code: 'menu_2_2_2',
                href: this.$router.options.base + 'publishedEforms',
                router: true,
                to: 'publishedEforms',
                active: false,
              },
              {
                id: '62',
                code: 'menu_4_4',
                href: this.$router.options.base + 'pickup',
                router: true,
                to: 'pickup',
                active: false,
              },
            ],
          },
        ],

        30: [
          {
            id: '30',
            code: 'menu_4_3',
            href: '/visor.auditoria',
            name: 'Auditoría',
          },
        ],
        86: [
          {
            id: '30',
            code: 'menu_4_6',
            href: this.$router.options.base + 'generalSettings',
            router: true,
            to: 'generalSettings',
            active: false,
          },
        ],
      },
      popupActive: false,
      showMenuLegajoDigital: false,
      showMenuLicencias: false,
      showMainMenu: false,
      permisionNotifications: false,
      notifications: 0,
    };
  }
  getMenu() {
    let menu = new Menu();
    let company = new Company();
    const promiseUser = menu.getUser();
    Promise.all([promiseUser])
      .then((values) => {
        let res = values[0].status === 200 ? values[0].data.results.data : [];

        let fil = _.map(res, function (n: any) {
          return Number(n.id);
        });
        let actions = _.map(this.actions, function (n, i) {
          return Number(i);
        });
        let userActions = _.filter(actions, function (n) {
          return _.includes(fil, n);
        });
        _.each(this.menu, function (a) {
          a.childsavailable = _.intersection(a.childs, userActions);
        });
        _.each(this.menu, function (a) {
          if (a.childsavailable.length > 0) {
            a.shown = _.some(a.childsavailable, (action) =>
              _.includes(fil, Number(action))
            );
          } else {
            a.shown = fil.includes(a.id);
          }
        });

        _.each(this.actions, (action, clave) => {
          _.map(action, (menu, i) => {
            if (_.has(menu, 'submenu')) {
              _.each(menu.submenu, (item, key) => {
                if (_.includes(fil, Number(item.id))) {
                  this.actions[clave][i].submenu[key].shown = true;
                }
              });
            }
          });
        });

        /** TODO: algoritmo vishero (mejorar) */
        Object.keys(this.actions).some((key) => {
          if (this.actions[key][0].to === this.$route.name) {
            this.actions[key][0].active = true;
            Object.keys(this.menu).some((index) => {
              Object.keys(this.menu[index].childs).some((i) => {
                if (this.menu[index].childs[i] === parseInt(key)) {
                  this.menu[index].active = true;
                  return false;
                }
              });
              return false;
            });
            return false;
          }
        });

        this.$store.dispatch('setMenu', { menu: this.menu });
        this.$store.dispatch('setActions', { actions: this.actions });
        this.$store.dispatch('setCleanAction');
        this.showMainMenu = true;
      })
      .catch((result: any) => {
        this.$router.push('/login');
      });
  }
  getPermisionNotifications() {
    let actions = new Actions();
    actions.getActions().then(async (res) => {
      const permission = res.data.results.data.some(
        (action) => action.id === '78'
      );
      if (permission) {
        this.permisionNotifications = true;
      } else {
        this.permisionNotifications = false;
      }
    });
  }
  getNotifications() {
    this.notifications = this.paginationResponse
  }

  get paginationResponse() {
    const response = this.$store.getters.isActionAllowed(305) ? this.$store.state.newDocumentsWaiting : this.$store.state.documentsWaiting;
    return response.hasOwnProperty('pagination') ? response.pagination.total ? response.pagination.total : response.pagination : 0
  }

  goTo(path) {
    this.$router.push({ name: path });
  }
  beforeCreate() {
    if (!localStorage.jwt) {
      this.$router.push('/login');
    }
  }
  async created() {
    this.showMainMenu = false;

    if (this.$store.getters.isActionAllowed(305)) {
      await this.$store.dispatch('setNewDocumentWaiting')
    } else {
      if (this.$store.getters.isActionAllowed(78)) {
        await this.$store
          .dispatch('setDocumentsWaiting', {
            perPage: 10,
            page: 1,
            orderParams: null,
          })
          .catch((err) => {
          });
      }
    }

    this.getMenu();
    this.getPermisionNotifications();
    this.getNotifications();
  }
}
